// What the Settings picker (CARD-1975) draws. It reads only this model, never the registry or storage.
// Pending themes are listed but cannot be selected. An appearance a theme does not offer is greyed.
import { THEMES, getTheme } from './registry.js'

const APPEARANCE_LABELS = { light: 'Light', dark: 'Dark', system: 'System' }

export function buildPickerModel({ themeId, appearanceSetting, themes = THEMES }) {
  const active = getTheme(themeId, themes)
  if (!active) throw new Error(`Unknown theme "${themeId}".`)
  return {
    themes: themes.map((t) => ({
      id: t.id,
      label: t.label,
      selectable: t.status === 'available',
      selected: t.id === themeId,
      note: t.status === 'available' ? null : 'Soon',
      appearances: [...t.appearances],
    })),
    appearances: ['light', 'dark', 'system'].map((value) => ({
      value,
      label: APPEARANCE_LABELS[value],
      selected: value === appearanceSetting,
      // System only means something when the theme offers both; a one-appearance theme stays on that one.
      enabled: value === 'system' ? active.appearances.length > 1 : active.appearances.includes(value),
    })),
  }
}
